var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.$router.currentRoute.name != 'login')?_c('Header'):_vm._e(),_c('v-content',[_c('v-container',{attrs:{"fluid":"","mb-12":"","fill-height":"","align-start":_vm.$router.currentRoute.name != 'login'}},[_c('router-view')],1)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }